module.exports = __webpack_public_path__ + "static/media/button-builder-main.fe0b24a9.png";